import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import AdminUserModal from '../AdminUserModal';
import CustomPagination from '../../CustomPagination';
import CommonTable from '../../CommonTable/CommonTable';
import TableAction from '../../CommonTable/TableAction';
import Loader from '../../Loader/Loader';

import { openAdminUserModal } from '../../../actions/siteadmin/modalActions';
import { deleteAdminUser } from '../../../actions/siteadmin/AdminUser/manageAdminUser';
import adminUserQuery from './adminUserQuery.graphql';
import adminRolesQuery from './adminRolesQuery.graphql';
import { withQuery } from '../../../hoc/withGraphql';
import debounce from '../../../helpers/debounce';
import { censorEmail, decode } from '../../../helpers/secureEmail';
import { demoRestrictionEncode } from '../../../helpers/DemoRestriction/demoRestriction';
import messages from '../../../locale/jsonMessages';

import cs from '../../../components/commonStyle.css';
import s from './AdminUserManagement.css';


class AdminUserManagement extends React.Component {

  static propTypes = {
    adminUsers: PropTypes.array,
    title: PropTypes.string.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      searchList: '',
      typing: false,
      typingTimeout: 0,
      isRestrict: false,
    }
    this.setStateVariable = this.setStateVariable.bind(this);
  }

  async componentDidMount() {
    const { demoRestrictionEncode } = this.props;
    const isRestrict = await demoRestrictionEncode();
    this.setState({ isRestrict });
  }

  setStateVariable(variables) {
    this.setState(variables);
  }

  paginationData = (currentPage) => {
    const { adminUsers: { refetch } } = this.props;
    let variables = { currentPage, searchList: this.state.searchList };
    this.setStateVariable(variables);
    refetch(variables);
  };

  handleKeywordSearch = debounce((value) => { // Keyword search
    const { adminUsers: { refetch }, setStateVariable } = this.props;
    let variables = {
      currentPage: 1,
      searchList: value
    };
    this.setStateVariable(variables);
    refetch(variables);
  }, 300)

  handleDelete = async (id) => {
    const { adminUsers: { refetch, getAllAdminUsers }, deleteAdminUser } = this.props;
    const { currentPage, searchList } = this.state;
    let variables = { currentPage: currentPage > 1 && getAllAdminUsers?.results?.length == 1 ? currentPage - 1 : currentPage, searchList };
    const deleteAdmin = await deleteAdminUser(id);
    if (deleteAdmin?.status === 200) {
      this.setStateVariable(variables);
      await refetch(variables);
    }
  };

  handleModalOpen = async (value) => {
    const { openAdminUserModal } = this.props;
    const { isRestrict } = this.state;
    if (value) openAdminUserModal('edit', value, isRestrict)
    else openAdminUserModal('add')
  }


  thead = () => {
    const { formatMessage } = this.props.intl;
    return [
      { data: formatMessage(messages.idLabel) },
      { data: formatMessage(messages.emailLabel) },
      { data: formatMessage(messages.adminRoleLabel) }
    ]
  };


  tbody = (props) => {
    const { adminUsers: { getAllAdminUsers } } = props;
    const { isRestrict } = this.state;

    return getAllAdminUsers?.results?.map((value, key) => {
      return {
        id: key,
        data: [
          { data: key + 1, },
          {
            data: <div className={cx(cs.displayFlex, cs.alignCenter, cs.spaceBetween)}>
              {isRestrict ? censorEmail(decode(value.email)) : decode(value.email)}
              <TableAction
                onClickDelete={() => this.handleDelete(value.id)}
                showDelete={true}
                showEdit={true}
                editAction={() => this.handleModalOpen(value)}
              /> </div>
          },
          { data: value.adminRole.name },
        ]
      }
    })
  }

  render() {
    const { adminUsers: { loading, getAllAdminUsers } } = this.props;
    const { adminRoles: { getAdminRoles } } = this.props;
    const { formatMessage } = this.props.intl;
    const { currentPage } = this.state

    if (loading) {
      return <Loader type={"text"} />
    }

    return (
      <div>
        <AdminUserModal paginationData={this.paginationData} roles={getAdminRoles} />
        <CommonTable
          thead={this.thead}
          tbody={() => this.tbody(this.props)}
          title={formatMessage(messages.manageAdminUsers)}
          isLink
          addAction={this.handleModalOpen}
          redirectionLabel={formatMessage(messages.addNewLabel)}
          isSearch
          onSearch={(e) => (this.handleKeywordSearch(e?.target?.value))}
        />
        {
          !loading && getAllAdminUsers?.count > 0 && <div>
            <CustomPagination
              total={getAllAdminUsers.count}
              currentPage={currentPage}
              defaultCurrent={1}
              defaultPageSize={10}
              change={this.paginationData}
              paginationLabel={formatMessage(messages.usersLabel)}
            />
          </div>
        }
      </div>
    );
  }

}

const mapState = (state) => ({});

const mapDispatch = {
  openAdminUserModal,
  deleteAdminUser,
  demoRestrictionEncode
};

export default compose(
  injectIntl,
  withStyles(cs, s),
  connect(mapState, mapDispatch),
  withQuery(adminUserQuery, {
    name: 'adminUsers',
    options: (props) => ({
      variables: {
        searchList: props.searchList,
        currentPage: props.currentPage,
      },
      fetchPolicy: 'network-only',
      ssr: false
    })
  }),
  withQuery(adminRolesQuery, {
    name: 'adminRoles',
    options: (props) => ({
      fetchPolicy: 'network-only',
      ssr: false
    })
  })
)(AdminUserManagement);